module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_yq_dkyy (1).1fdb2397.png";